import { LedgerActivityReportItem } from '@mews-commander/data-access';
import { sumNumbersAsDecimals } from '@mews/framework';

export function sumTotalValues(items: LedgerActivityReportItem[], key: keyof LedgerActivityReportItem): number {
    return items.reduce((sum, item) => {
        const value = item[key];
        return sumNumbersAsDecimals(sum, typeof value === 'number' ? value : 0);
    }, 0);
}
